import React from 'react';
import {
  TextField,
  Box
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface RevisionRequestInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  userType?: 'csm' | 'client';
}

const RevisionRequestInput: React.FC<RevisionRequestInputProps> = ({
  value,
  onChange,
  error,
  userType = 'csm'
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: 2, mb: 3 }}>
      <TextField
        fullWidth
        multiline
        rows={4}
        label={t('proposal.revision.messageLabel')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        error={!!error}
        helperText={error || t(`proposal.revision.messageHelperText.${userType}`)}
        required
        placeholder={t(`proposal.revision.messagePlaceholder.${userType}`)}
      />
    </Box>
  );
};

export default RevisionRequestInput;
